import { prepareDocForUpdate } from './helpers/firestoreHelpers'

const updateCard = (cardRef, values) => {
  return cardRef
    .set(prepareDocForUpdate(values), {merge: true})
}

export default updateCard
